<template>
  <footer id="bottom">
    <div id="bottom_container">
      <div id="bottom-left_container">
        <div id="bottom-logo" />
        <div id="bottom-copyright">&copy; 2022 Adelaide Metrics, Inc.</div>
      </div>
      <div id="bottom-right_container">
        <div id="bottom-links_container">
          <a class="bottom-links" id="bottom-links-support" :href="`mailto:${this.support_email}`">{{this.support_email}}</a>
          <a class="bottom-links" id="bottom-links-privacy" target="_blank" href="https://adelaidemetrics.com/privacy">Privacy Policy</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>

export default {
  name: 'bottom',
  data() {
    return {
      support_email: 'support@adelaidemetrics.com',
    };
  },
};
</script>

<style>

/* parent footer element*/
#bottom {
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  color: #900c3e;
  background-color: #eee8ec;
  padding: 12px 30px;
}

#bottom_container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

#bottom-left_container {
  align-items: center;
  display: flex;
}

#bottom-right_container {

}

/* center logo */
#bottom-logo {
  display: inline-block;
  background-image: url('~@/assets/logo/a-logomark-purple.svg');
  background-size: 100% auto;
  background-repeat: no-repeat;
  width: 38px;
  height: 38px;
  flex-shrink: 0;
  margin: 0 18px 0 0;
}

#bottom-copyright {
  color: #555;
}

/* footer links */
#bottom-links_container {
  text-align: right;
}

.bottom-links {
  display: inline-block;
  padding: 5px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s all ease;
}

/* privacy link */
#bottom-links-privacy {
  margin-left: 22px;
  padding-left: 22px;
  border-left: 2px solid #fff;
}

.bottom-links:hover {
  color: #4c123e;
}

/* accommodations for wide nav pages */
.page-wide #bottom {
  width: 228px;
  z-index: 10;
  height: 90px;
}

.page-wide #bottom-logo {
  background-image: url('~@/assets/logo/logotype-white-2x.png');
  background-size: 65% auto;
}

.page-wide #bottom-links-privacy {
  display: none;
}

.page-wide .bottom-links {
  font-size: 14px;
}

.page-wide .bottom-links:hover {
  opacity: 0.5;
}

</style>
